module.exports = __webpack_public_path__ + "static/media/alex.0d9c9c60.jpg";